import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['wrapper'];
  initialize() {
    const observer = new IntersectionObserver(
      ([e]) => e.target.classList.toggle('flat', e.intersectionRatio < 1),
      { threshold: [1] }
    );

    observer.observe(this.wrapperTarget);
  }
}
